import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()

export class HttpService {
    constructor(private http: HttpClient) { }

    getAll(apiUrl: string): Observable<any[]> {
        return this.http.get<any[]>(apiUrl);
    }

    getById(apiUrl: string): Observable<any> {
        return this.http.get<any>(apiUrl);
    }

    getWithParams(apiUrl: string, params: HttpParams): Observable<any> {
        return this.http.get<any>(apiUrl, { params: params });
    }

    create(apiUrl: string, bodyData: any): Observable<any> {
        return this.http.post<any>(apiUrl, bodyData);
    }

    post(apiUrl: string, bodyData: any): Observable<any> {
        return this.http.post<any>(apiUrl, bodyData);
    }

    update(apiUrl: string, bodyData?: any): Observable<any> {
        return this.http.put<any>(apiUrl, bodyData);
    }

    put(apiUrl: string, bodyData?: any): Observable<any> {
        return this.http.put<any>(apiUrl, bodyData);
    }

    delete(apiUrl: string): Observable<any> {
        return this.http.delete<any>(apiUrl);
    }

}
